// extracted by mini-css-extract-plugin
export var md = "_4l-4";
export var semantic = "_4l-5";
export var sm = "_4l-3";
export var text = "_4l-6";
export var toggleInput = "_4l-0";
export var toggleSwitch = "_4l-1";
export var xs = "_4l-2";